import { Alert, Box, Button, Tab, Tabs, Typography } from "@mui/material";
import { createMRTColumnHelper } from "material-react-table";
import { useContext, useEffect, useState } from "react";
import toast from "react-hot-toast";
import { useNavigate, useParams } from "react-router-dom";
import MDAlert from "../../components/MDAlert";
import MDTypography from "../../components/MDTypography";
import { AuthContext } from "../../context";
import DashboardLayout from "../../examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "../../examples/Navbars/DashboardNavbar";
import apiService from "../../services/api-service";
import GenericForm from "../genericForm";
import GenericTable from "../genericTable";

function EditWbs() {
	const authContext = useContext(AuthContext);
	const [activeTab, setActiveTab] = useState(0);
	const { id } = useParams();
	const navigate = useNavigate();
	const columnHelper = createMRTColumnHelper();

	const handleChange = (event, newValue) => {
		setActiveTab(newValue);
	};

	const [personalData, setPersonalData] = useState({}); // Dati personali da query
	const [associatedAreaRolesData, setAssociatedAreaRolesData] = useState([]); // Dati delle aree associate
	const [childrenData, setChildrenData] = useState([]); // Dati dei contatti
	const [showformAree, setShowFormAree] = useState(false);
	const [editAreaRole, setEditAreaRole] = useState(false);
	const [showFormChildren, setShowFormChildren] = useState(false);
	const [editChildrenData, setEditChildrenData] = useState({});
	const [editChildren, setEditChildren] = useState(false);
	const [editAreaRoleData, setEditAreaRoleData] = useState({});
	const [areeOption, setAreeOption] = useState([]);
	const [rolesOption, setRolesOption] = useState([]);
	const [contactsOption, setContactsOption] = useState([]);
	const [error, seterror] = useState("");

	function fetchPersonal() {
		apiService
			.get("/jobs-management/", { id: id }, {})
			.then((data) => {
				setPersonalData({ ...data["job"], id: id });
				setChildrenData(data["children"]);
			})
			.catch((error) => toast.error("Errore durante il caricamento dei dati. Riprova più tardi se l'errore persiste contatti il supoorto tecnico indicato l'errore #00085", { id: "edit-wbs-toast" }));
	}

	useEffect(() => {
		fetchPersonal();
	}, []);

	const handleSavePersonalData = (data) => {
		console.log("Salva Dati Personali:", data);
	};

	async function deleteResource(params, endpoint) {
		try {
			// Parametri opzionali per la richiesta DELETE
			const headers = {}; // Headers opzionali

			// Esegui la chiamata DELETE
			const response = await apiService.delete(endpoint, params, headers);

			// Se arriviamo qui, la chiamata è andata a buon fine
			console.log(`Risorsa con id ${id} eliminata con successo:`, response);

			// Puoi fare qualcosa con la risposta, se necessario
			return response;
		} catch (error) {
			// Gestisci eventuali errori
			console.error(`Errore durante l'eliminazione della risorsa con id ${id}:`, error.message);

			// Puoi gestire l'errore in modo specifico, ad esempio:
			if (error.message.includes("404")) {
				console.log(`La risorsa con id ${id} non è stata trovata`);
			} else if (error.message.includes("403")) {
				console.log(`Non hai i permessi per eliminare la risorsa con id ${id}`);
			}

			// Rilancia l'errore se vuoi che venga gestito a un livello superiore
			throw error;
		}
	}

	function handleDelete(id) {
		deleteResource({ id: id }, "/jobs-children-management/")
			.then((result) => {
				toast.success(`Sotto attività eliminato con successo`, { id: "edit-wbs-toast" });
				fetchPersonal();
			})
			.catch((error) => {
				// Gestisci l'errore se non è stato gestito nella funzione
				toast.error(`Si è verificato un errore durante l'eliminazione della Sotto attività. Riprova più tardi se l'errore persiste contatta il supporto tecnico indicato l'errore #991089711710010511132109117111114105`, { id: "edit-wbs-toast" });
			});
	}

	function handleEdit(id) {
		setShowFormChildren(true);
		setEditChildren(true);
		setEditChildrenData(childrenData.find((child) => child.id === id));
	}

	function turnOffFormChildren() {
		fetchPersonal();
		setShowFormChildren(false);
		setEditChildren(false);
	}

	return (
		<DashboardLayout>
			{authContext.hasAuth("EDIT_JOBS") ? (
				<>
					<DashboardNavbar />
					<Box sx={{ width: "100%" }}>
						<Button variant="contained" color="primary" onClick={() => navigate("/wbs-managment")} sx={{ mt: 2, alignSelf: "center", minWidth: "100px", color: "#ffffff", marginBottom: "30px" }}>
							Torna alla tabella WBS
						</Button>
						<Tabs value={activeTab} onChange={handleChange} centered>
							<Tab label="Dati WBS" />
							<Tab label="Sotto attività" />
						</Tabs>

						<TabPanel value={activeTab} index={0}>
							<GenericForm
								authModelName={"JOBS"}
								old_data={personalData}
								url="/jobs-management/"
								useAPI={true} // cambia a true per usare l'API
								executeOnSuccess={true}
								executeOnSuccessTask={fetchPersonal}
								requiredFields={[
									{ name: "name", nameDiplayed: "nome" },
									{ name: "code", nameDiplayed: "codice WBS" },
								]}
								inputFields={[
									{
										type: "text",
										name: "code", // Nome nel DB
										label: "Codice WBS", // Etichetta visibile
									},
									{
										type: "text",
										name: "name", // Nome nel DB
										label: "Nome", // Etichetta visibile
									},
								]}
							/>
						</TabPanel>

						<TabPanel value={activeTab} index={1}>
							{authContext.hasAuth("ADD_JOBS") || (authContext.hasAuth("EDIT_JOBS") && showFormChildren) ? (
								<center>
									<Button
										variant="contained"
										color="info"
										onClick={() => {
											setShowFormChildren(!showFormChildren);
											setEditChildren(false);
										}}
										sx={{
											mt: 2,
											alignSelf: "center",
											minWidth: "100px",
											color: "#000000",
											marginBottom: "30px",
											marginTop: "20px",
										}}
									>
										{showFormChildren ? "Torna alla tabella" : "Aggiungi"}
									</Button>
								</center>
							) : null}
							{error !== "" ? (
								<Alert severity="error">{error}</Alert>
							) : !showFormChildren ? (
								<GenericTable
									authModelName={"JOBS"}
									columns={[
										columnHelper.accessor("secondary_code", {
											header: "sotto Codice",
											size: 120,
										}),
										columnHelper.accessor("name", {
											header: "Nome",
											size: 120,
										}),
									]}
									data={childrenData}
									onDelete={(id) => handleDelete(id)}
									onEdit={(id) => handleEdit(id)}
								/>
							) : !editChildren ? (
								<GenericForm
									authModelName={"JOBS"}
									formData={{ father: id }}
									url="/jobs-children-management/"
									executeOnSuccessTask={fetchPersonal}
									executeOnSuccess={true}
									useAPI={true}
									requiredFields={[
										{ name: "secondary_code", nameDiplayed: "Sotto codice" },
										{
											name: "name",
											nameDiplayed: "Nome",
										},
									]}
									inputFields={[
										{
											type: "text",
											name: "secondary_code", // Nome nel DB
											label: "Sotto codice", // Etichetta visibile
										},
										{
											type: "text",
											name: "name", // Nome nel DB
											label: "Nome", // Etichetta visibile
										},
									]}
								/>
							) : (
								<GenericForm
									authModelName={"JOBS"}
									old_data={{ ...editChildrenData, father: id }}
									url="/jobs-children-management/"
									useAPI={true}
									executeOnSuccessTask={turnOffFormChildren}
									executeOnSuccess={true}
									requiredFields={[
										{ name: "secondary_code", nameDiplayed: "Sotto codice" },
										{
											name: "name",
											nameDiplayed: "Nome",
										},
									]}
									inputFields={[
										{
											type: "text",
											name: "secondary_code", // Nome nel DB
											label: "Sotto codice", // Etichetta visibile
										},
										{
											type: "text",
											name: "name", // Nome nel DB
											label: "Nome", // Etichetta visibile
										},
									]}
								/>
							)}
						</TabPanel>
					</Box>
				</>
			) : (
				<MDAlert color="error" dismissible>
					<MDTypography variant="body2">You don't have permission to access this page</MDTypography>
				</MDAlert>
			)}
		</DashboardLayout>
	);
}

function TabPanel(props) {
	const { children, value, index, ...other } = props;

	return (
		<div role="tabpanel" hidden={value !== index} id={`tabpanel-${index}`} aria-labelledby={`tab-${index}`} {...other}>
			{value === index && (
				<Box sx={{ p: 3 }}>
					<Typography component="div">{children}</Typography>
				</Box>
			)}
		</div>
	);
}

export default EditWbs;
